import { LibraryItemType } from "./LibraryItemType";
import { AssetCategory, toAssetCategoryFromNumber } from "./AssetCategory";
import { Modify } from "../utilities/modifyType";

export interface PremiumSermonSeriesAsset {
    id: string;
    premiumSermonSeriesId: number;
    parentId?: string;
    type: LibraryItemType;
    name: string;
    category?: AssetCategory;
    builderAssetText: string;
    linkAssetUrl: string;
    fileAssetLocation: string;
    fileAssetSize?: string;
    fileAssetExtension: string;
    fileAssetMimeType: string;
}

export type SerializedPremiumSermonSeriesAsset = Modify<PremiumSermonSeriesAsset, {}>

export function deserializePremiumSermonSeriesAsset(asset:SerializedPremiumSermonSeriesAsset): PremiumSermonSeriesAsset{
    return {
        ...asset,
        category: asset.category && !isNaN(+asset.category) ? toAssetCategoryFromNumber(+asset.category) : undefined,
    }
}
